import React, { useReducer } from "react";
export const EMPTY_ONFIDO_STATE = {
    gdprCheck: false,
};
export const OnfidoContext = React.createContext({});
export const withOnfido = (Component) => (props) => (React.createElement(OnfidoContext.Consumer, null, (contextProps) => React.createElement(Component, Object.assign({}, props, contextProps))));
function stateReducer(state, newState) {
    return Object.assign(Object.assign({}, state), newState);
}
export const OnfidoContextProvider = ({ children }) => {
    const [state, setState] = useReducer(stateReducer, EMPTY_ONFIDO_STATE);
    return (React.createElement(OnfidoContext.Provider, { value: { state, setState } }, children));
};
